import { NgModule } from '@angular/core';
import { SharedDialogComponent } from './shared-dialog/shared-dialog.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { SvgIconComponent } from './svg-icon/svg-icon.component';
import { ButtonComponent } from './button/button.component';
import { FormFieldComponent } from './form-field/form-field.component';
import { TableColumnSettingsComponent } from './table-column-settings/table-column-settings.component';
import { CopyableComponent } from './copyable/copyable.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { BulkActionsBarComponent } from './bulk-actions-bar/bulk-actions-bar.component';
import { AiClassificationTagComponent } from './ai-classification-tag/ai-classification-tag.component';
import { IconComponent } from './icon/icon.component';
import { NavItemComponent } from './nav-item/nav-item.component';
import { NavSectionComponent } from './nav-section/nav-section.component';
import { SidebarFooterComponent } from './sidebar-footer/sidebar-footer.component';
import { StatusBadgeComponent } from './status-badge/status-badge.component';
import { CoachMarkComponent } from './ftue/coach-mark/coach-mark.component';
import { FtueLayerComponent } from './ftue/ftue-layer/ftue-layer.component';
import { FtueInspectorComponent } from './ftue/ftue-inspector/ftue-inspector.component';
import { InitialsTagComponent } from './initials-tag/initials-tag.component';
import { SegmentedBarComponent } from './segmented-bar/segmented-bar.component';
import { FilterActionComponent } from './filter-action/filter-action.component';
import { FilterSelectComponent } from './filter-select/filter-select.component';

const UI_COMPONENTS = [
  ButtonComponent,
  PageHeaderComponent,
  SvgIconComponent,
  FormFieldComponent,
  SharedDialogComponent,
  TableColumnSettingsComponent,
  CopyableComponent,
  CheckboxComponent,
  BulkActionsBarComponent,
  AiClassificationTagComponent,
  StatusBadgeComponent,
  InitialsTagComponent,
  SegmentedBarComponent,
  FilterActionComponent,
  FilterSelectComponent,
  // Sidebar navigation primitives (WB-7455)
  IconComponent,
  NavItemComponent,
  NavSectionComponent,
  SidebarFooterComponent,
  // First-time experience: tip card, its renderer, and the dev inspector (WB-7535)
  CoachMarkComponent,
  FtueLayerComponent,
  FtueInspectorComponent,
];

@NgModule({
  declarations: [],
  imports: [...UI_COMPONENTS],
  exports: [...UI_COMPONENTS],
})
export class UiModule {}
